module.exports = __webpack_public_path__ + "static/img/pic11.732c57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic11.png
// module id = pwep
// module chunks = 0